//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { Opaque } from '@utils/opaque';

/**
 * Unique identifier for a bvClientId in Bazaarvoice.
 * Example of a bvClientId: sheamoisture
 */
export type BazaarvoiceClientId = Opaque<string, 'BazaarvoiceClientId'>;

function BazaarvoiceClientIdFactory(bvClientId: string): BazaarvoiceClientId {
  return bvClientId as BazaarvoiceClientId;
}

export const BazaarvoiceClientId = BazaarvoiceClientIdFactory;
